module.exports = __webpack_public_path__ + "img/office2.780e7eb1.jpg";